import React from 'react';
import RichText from 'components/rich-text';
import Grid from 'components/grid';
import PropTypes from 'prop-types';

const ProductDescription = ({ content }) => (
  <div className="product-description">
    <Grid
      className="product-description__content"
      theme={Grid.themes.leftColumnWider}
    >
      <Grid.Column className="product-description__col">
        <RichText
          text={content}
          hasBottomMargin={false}
          isCentered={false}
          className="rich-text--in-product-description product-description__text"
        />
      </Grid.Column>
    </Grid>
  </div>
);

ProductDescription.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string,
  content: PropTypes.string
};

export default ProductDescription;
